import { InfoWrapper, Input } from 'app/components';
import { NotificationRuleSettingsT } from 'app/types/types';
import { useTranslation } from 'react-i18next';

import styles from '../CreateNotificationModal.module.scss';
import { AreaInField } from 'app/components/FilterPanel/AreaInField';
import { VesselField } from 'app/components/FilterPanel/VesselField';


export const RuleForAnArea = ({
  errors,
  onAreaChange,
  isAnyCheckedState,
}: NotificationRuleSettingsT<any>) => {
  const { t } = useTranslation();
  const [isAnyChecked, setIsAnyChecked] = isAnyCheckedState;
  return (
    <div className={styles.row}>
      <InfoWrapper
        label={t('Area')}
        value={
          <div className={styles.row_item}>
            <AreaInField fieldName="area" onSelect={onAreaChange} />
          </div>
        }
      />
      <div className={styles.row_title}>{t('Vessel')}:</div>
      <Input label={t('AnyVessel')} name="mmsi" type="radio" onChange={() => setIsAnyChecked(true)} checked={isAnyChecked} />
      <InfoWrapper
        label={
          <Input
            label={t('ChosenVessel')}
            name="mmsi"
            type="radio"
            onChange={() => setIsAnyChecked(false)}
            checked={!isAnyChecked}
          />
        }
        value={
          <div className={styles.row_item}>
            <VesselField fieldName={'mmsi'} onSelect={onAreaChange} />
            {errors.mmsi && <div className={styles.error_message}>{t(errors.mmsi)}</div>}
          </div>
        }
      />
    </div>
  );
};
